import "./css/styles.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, {Component} from "react";
import moment from 'moment';
import TelevisionBreakpoint from "../../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../../components/responsive_utilities/phone_breakpoint";
import { Logs } from "./comps/Logs";
import { ScrollerTv } from "../pescadora/comps/ScrollerTv"
import { Scroller } from "../pescadora/comps/Scroller"


var firebase = require('firebase/app');
require('firebase/database');

class PescadoraLogs extends Component {
  
  constructor() {
    super();
    this.state = {
      time: new Date(),  
      tournament: [],
      tourDay1: '',
      tourDay2: '',
      tourDay3: '',
      tourDay4: '',
      countDownDate: '',
      buttonStatus: 'current',
      buttonStatus1: 'notCurrent',
      buttonStatus2: 'notCurrent',
      buttonStatus3: 'notCurrent',
      buttonStatus4: 'notCurrent',
      tournamentLogo: '',
      tournamentName: '',
      boats: [],
			teamNums: '',
      anglersRaw: {},
			anglerNums: '',
      species: [],
      speciesRaw: {},
      boatsRaw: {},
      currentLogs: {},
      currentBoatScores: [],
      logs: [],
      fishLogs: [],
      fishLogsOne: [],
      fishLogsTwo: [],
      fishLogsThree: [],
      fishLogsFour: [],
      hookups: [],
      hps: [],
      boatLogs: [],
      boatTotals: [],
      boatTotalsOne: [],
      boatTotalsTwo: [],
      boatTotalsThree: [],
      boatTotalsFour: [],
      boatScores: [],
      boatScoresOne: [],
      boatScoresTwo: [],
      boatScoresThree: [],
      boatScoresFour: [],
      boatScoresArray: [],
      showAll: true,
      showDay1: false,
      showDay2: false,
      showDay3: false,
      showDay4: false,
      newLog: false,
      newItem: false,
      playing: 'STOPPED',
      vidPlaying: true,
      loading: true,
      newFishLog: [],
      vidLogs: [],
      vidList: [],
      currentVideo: '',
      boardId: '',
      boardName: '',
      videoVis: 'visible',
      displayVis: 'inline',
      loadingVis: 'none',
      loadingVis2: 'inline',
      speciesPoints: [],
      boatFishLogs: [],
      tourDay: '',
      currentTourDay: '',
			currentDayState: 'All'
    };
    this.baseRef = firebase.database().ref('/');
    this.ref = firebase.database().ref('tournaments');
    this.tourRef = firebase.database().ref('tournaments/-LQoim5R3GFJ0t76EEBd');
    this.handleButtonPress = this.handleButtonPress.bind(this)
    this.handleButtonRelease = this.handleButtonRelease.bind(this)
  }
  
  componentWillMount() {
    this.tourRef.on('value', this.handleTournamentUpdate); 
    this.tourRef.child('fishLogs').on('child_added', this.handleFishLogAdded);
    this.tourRef.child('fishLogs').on('child_changed', this.handleFishLogChanged);
    this.baseRef.child('refresh').on('child_changed', this.reloadPage);
	  this.baseRef.child('refreshPlaylist').on('child_changed', this.reloadPlaylist);
  }
  
  componentDidMount() {
    window.addEventListener("keyup", this.keyHandling);
    this.fetchVideosList();
    setInterval(this.update, 1000)
  }
    
  componentWillReceiveProps(newProps) {
    this.setState({tourDay: this.props.match.params.tourDay});
    this.getBoats();
  }

  update = () => {
		this.setState({
			time: new Date()
		})
		
	};
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    }
  }
  
  reloadPage = () => {
    window.location.reload(true);
  }
	
	reloadPlaylist = () => {
    this.fetchVideosList();
  }
  
  handleTournamentUpdate = (snapshot) => { 
    if(snapshot.val().fishLogs) {
      var fishLogsArray = Object.entries(snapshot.val().fishLogs);
    }
    var fishLogsList = [];
    var hookupsList = [];
    var speciesArray = Object.entries(snapshot.val().species);
    var speciesList = [];
    var boatsArray = Object.entries(snapshot.val().boats);
    var boatsList = [];
    if(snapshot.val().videos) {
        var tourVideos = Object.entries(snapshot.val().videos);
    }
      
    if(fishLogsArray) {
      fishLogsArray.forEach((log) => {
        fishLogsList.push({
          id: log[0],
          boatId: log[1].boatId,
          boatName: log[1].boatName,
					teamName: log[1].name,
          boatThm: log[1].photoUrl,
          speciesId: log[1].speciesId,
          speciesName: log[1].speciesName,
          anglerId: log[1].anglerId,
          anglerName: log[1].anglerName,
          lbs: log[1].fishLbs,
          hookedupDate: log[1].hookedupDate,
          catchDate: log[1].catchDate,
          clipUrl: log[1].clipUrl,
          status: log[1].status
        });
        if (log[1].status === 'hooked up'){
          hookupsList.push ({
            id: log[0],
            boatId: log[1].boatId,
            boatName: log[1].boatName,
						teamName: log[1].name,
            boatThm: log[1].photoUrl,
            speciesId: log[1].speciesId,
            speciesName: log[1].speciesName,
            anglerId: log[1].anglerId,
            anglerName: log[1].anglerName,
            lbs: log[1].fishLbs,
            hookedupDate: log[1].hookedupDate,
            status: log[1].status
          })
        }
      })
    }
    
    var countDownDate = moment(new Date(snapshot.val().day1Date)).format('LLL');
    var tournament = {
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
			tournamentTimeZone: snapshot.val().timeZone,
      venue: snapshot.val().venue,
      captMeetingTime: snapshot.val().captMeetingTime,
      captMeetingLoc: snapshot.val().captMeetingLoc,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      anglersRaw: snapshot.val().anglers,
      boatsRaw: snapshot.val().boats,
    }
    
    this.setState({
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
			tournamentTimeZone: snapshot.val().timeZone,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      species: speciesList, 
      speciesRaw: snapshot.val().species,
      anglersRaw: snapshot.val().anglers,
			anglerNums: Object.keys(snapshot.val().anglers).length,
      boatsRaw: snapshot.val().boats,
			teamNums: Object.keys(snapshot.val().boats).length,
      boats: boatsList,
      hps: hookupsList,
      newItem: true,
      fishLogs: this.sortFishLogs(fishLogsList),
      countDownDate,
      tournament
    });
      
    speciesArray.forEach((specie) => {
      speciesList.push({
        id: specie[0],
        name: specie[1].name,
        points: specie[1].points,
        scoreType: specie[1].scoreType,
        speciesImageUri: specie[1].speciesImageUri
      })
    })
    
    boatsArray.forEach((boat) => {
      boatsList.push({
        id: boat[0],
        name: boat[1].name,
				teamName: boat[1].name,
				boatName: boat[1].boatName,
        class: boat[1].boatClass,
        photoURL: boat[1].photoUrl,
      })
    })
		
		
    this.getBoats();
  }
  
  isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
  }

  filterDailyLogs(day, logs){
      var theDay = day.substring(0,10);
      var fishLogs =  logs.filter(function(log) {
        return log.catchDate.substring(0,10) == theDay;
      });
      var sortedLogs = this.sortFishLogs(fishLogs)
      return sortedLogs
  }
  
  
  sortFishLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    return logs
  }
  
  handleFishLogAdded = (snapshot) => {
    if (!this.state.newItem) return;
    var fishLogs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDate) {
      var hd = this.formatDate(snapshot.val().hookedupDate);
    } else {
      var hd = null;
    }
      fishLogs.unshift({
        id: snapshot.key,
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
				teamName: snapshot.val().name,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        lbs: snapshot.val().fishLbs,
        anglerId: snapshot.val().anglerId,
        anglerName: snapshot.val().anglerName,
        photoUrl: snapshot.val().photoUrl,
        status: snapshot.val().status,
        hookedupDate: hd,
        catchDate: cd,
        });
      this.setState({
        vidLogs,
        newLog: true,
        vidPlaying: false,
        displayVis: 'none',
        newFishLog: {
          boatId: snapshot.val().boatId,
          boatName: snapshot.val().boatName,
					teamName: snapshot.val().name,
          photoUrl: snapshot.val().photoUrl,
          anglerName: snapshot.val().anglerName,
          anglerId: snapshot.val().anglerId,
          speciesId: snapshot.val().speciesId,
          speciesName: snapshot.val().speciesName,
          fishLbs: snapshot.val().fishLbs,
          status: snapshot.val().status,
          hookedupDate: hd,
          catchDate: cd,
        }
      })
    setTimeout(function() { this.setState({newLog: false}); }.bind(this), 10000);
    setTimeout(function() { this.setState({displayVis: 'inline'}); }.bind(this), 10000);
    setTimeout(function() { this.setState({vidPlaying: true}); }.bind(this), 10500);
  }
  
  sortLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    this.getBoats();
  }
  
  handleFishLogChanged = (snapshot, last) => {
    var logs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDateDate) {
      var hd = this.formatDate(snapshot.val().hookedupDateDate);
    } else {
      var hd = null;
    }
    vidLogs.push({
      id: snapshot.key,
      boatId: snapshot.val().boatId,
      boatName: snapshot.val().boatName,
      speciesId: snapshot.val().speciesId,
      speciesName: snapshot.val().speciesName,
      lbs: snapshot.val().fishLbs,
      anglerId: snapshot.val().anglerId,
      anglerName: snapshot.val().anglerName,
      catchDate: this.formatDate(snapshot.val().catchDate),
      clipUrl: snapshot.val().clipUrl,
      status: snapshot.val().status
    })
    logs.map(log => {
      if(log.id === snapshot.key) {
        log.lbs = snapshot.val().fishLbs;
        log.boatId = snapshot.val().boatId;
        log.boatName = snapshot.val().boatName;
        log.speciesId = snapshot.val().speciesId;
        log.speciesName = snapshot.val().speciesName;
        log.anglerId = snapshot.val().anglerId;
        log.anglerName = snapshot.val().anglerName;
        log.catchDate = this.formatDate(snapshot.val().catchDate);
        log.clipUrl = snapshot.val().clipUrl;
        log.status = snapshot.val().status;
      }
    });
    this.setState({
      vidLogs,
      fishLogs:logs,
      newLog: true,
      vidPlaying: false,
      videoVis: 'hidden',
      displayVis: 'none',
      newFishLog: {
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
				teamName: snapshot.val().name,
        photoUrl: snapshot.val().photoUrl,
        anglerName: snapshot.val().anglerName,
        anglerId: snapshot.val().anglerId,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        fishLbs: snapshot.val().fishLbs,
        status: snapshot.val().status,
        hookedupDateDate: hd,
        catchDate: cd,
        }
    })
    this.getBoats();
    setTimeout(function() { this.setState({newLog: false}) }.bind(this), 10000);
    setTimeout(function() { this.setState({displayVis: 'inline'}) }.bind(this), 10000);
    setTimeout(function() { this.setState({vidPlaying: true}); }.bind(this), 10500);
  }
	
	fetchVideosList() {
		const API = 'AIzaSyDPOAO90Hmjyg73TusAFE4-OfbaDIkfkwU'
		const channelID = 'PLBE2HTUQ9kZvPk-l5-parBnu5a4e6iZA7'
		const results = 20;
		var vidList = [];
		
		var finalURL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${channelID}&maxResults=${results}&key=${API}`;
		
		fetch(finalURL)
      .then((response) => response.json())
      .then((resp) => { 
				resp.items.forEach((item) => {
					vidList.push({
						url: 'https://youtu.be/' + item.snippet.resourceId.videoId,
						title: item.snippet.title,
						desc: item.snippet.description
					})
				})
				this.setState({
					vidList,
					currentVideo: vidList[0],
				})
      })
      .catch((error) => {
        console.error(error);
      });
	}
  
  getBoats() {
    var logs = this.state.fishLogs;
    var boats = this.state.boats;
    var boatLogs = [];
    var boatLogsOne = [];
    var boatLogsTwo = [];
    var boatLogsThree = [];
    var boatLogsFour = [];
    boats.forEach((boat) => {
      var boatFish = [];
      var boatFishOne = [];
      var boatFishTwo = [];
      var boatFishThree = [];
      var boatFishFour = [];
      
      //Get FishLog for each Boat
      logs.forEach((fishLog) => {
        if(!fishLog.catchDate){
          return
        }
        if(boat.id === fishLog.boatId){
          if(fishLog.length !== 0) {
            boatFish.push(fishLog);
          }
        }
        if(this.state.tourDay1.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishOne.push(fishLog);
            }
          }
        } else if(this.state.tourDay2.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishTwo.push(fishLog);
            }
          }
          
        } else if(this.state.tourDay3.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishThree.push(fishLog);
            }
          }
        } else if(this.state.tourDay4.substring(0,10) === fishLog.catchDate.substring(0,10)) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishFour.push(fishLog);
            }
          }
        }
      });
      if(boatFish.length !== 0) {
        boatFish.sort(function(a, b) {
            var dateA = new Date(a.catchDate), dateB = new Date(b.catchDate);
            return dateA - dateB;
        });
        var lastFishInt = (boatFish.length - 1);
        var lastFishTime = boatFish[lastFishInt].catchDate;
				var teamName = boatFish[0].teamName;
        boatLogs.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFish,
          lastFishTime:  lastFishTime
        });
      }
      if(boatFishOne.length !== 0) {
        var lastFishIntOne = (boatFishOne.length - 1);
        var lastFishTimeOne = boatFishOne[lastFishIntOne].catchDate;
				var teamName = boatFishOne[0].teamName;
        boatLogsOne.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishOne,
          lastFishTime:  lastFishTimeOne
        });
      } 
      
      if(boatFishTwo.length !== 0) {
        var lastFishIntTwo = (boatFishTwo.length - 1);
        var lastFishTimeTwo = boatFishTwo[lastFishIntTwo].catchDate;
				var teamName = boatFishTwo[0].teamName;
        boatLogsTwo.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishTwo,
          lastFishTime:  lastFishTimeTwo
        });
      }
      if(boatFishThree.length !== 0) {
        var lastFishIntThree = (boatFishThree.length - 1);
        var lastFishTimeThree = boatFishThree[lastFishIntThree].catchDate;
				var teamName = boatFishThree[0].teamName;
        boatLogsThree.push({
          boatId: boat.id,
          boatName: boat.boatName,
					teamName,
          boatClass: boat.class,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishThree,
          lastFishTime:  lastFishTimeThree
        });
      }
      
      if(boatFishFour.length !== 0) {
        var lastFishIntFour = (boatFishFour.length - 1);
        if(lastFishIntFour) {
          var lastFishTimeFour = boatFishFour[lastFishIntFour].catchDate;
					var teamName = boatFishFour[0].teamName;
          boatLogsFour.push({
            boatId: boat.id,
            boatName: boat.boatName,
						teamName,
            boatClass: boat.class,
            boatThm: boat.photoURL,
            boatCaughtFish: boatFishFour,
            lastFishTime: lastFishTimeFour
          });
        }
      }
    });
    var bTotals = this.getBoatTotals(boatLogs);
    var bTotalsOne = this.getBoatTotals(boatLogsOne);
    var bTotalsTwo = this.getBoatTotals(boatLogsTwo);
    var bTotalsThree = this.getBoatTotals(boatLogsThree);
    var bTotalsFour = this.getBoatTotals(boatLogsFour);
    this.setState({
      logs: boatLogs,
      currentLogs: boatLogs,
      fishLogsOne: boatLogsOne,
      fishLogsTwo: boatLogsTwo,
      fishLogsThree: boatLogsThree,
      fishLogsFour: boatLogsFour,
      currentBoatScores: this.scoreSortFilter(bTotals),
      boatScores: this.scoreSortFilter(bTotals),
      boatScoresOne: this.scoreSortFilter(bTotalsOne),
      boatScoresTwo: this.scoreSortFilter(bTotalsTwo),
      boatScoresThree: this.scoreSortFilter(bTotalsThree),
      boatScoresFour: this.scoreSortFilter(bTotalsFour),
    })
    setTimeout(this.toggleLoading, 3000)
  }

  toggleLoading = () => {
    this.setState({
        loading: false,
        loadingVis: 'inline',
        loadingVis2: 'none',
      });
  }

  getBoatTotals(bLogs) {
    var boatTotals = [];
    bLogs.forEach((boatLog) => {
      var logs = boatLog.boatCaughtFish;
      var sps = this.state.species;
      var boatCounts = [];
      var boatPoints = [];
      var boatLbsPoints = [];
      var boatTotal = '';
      
      sps.forEach((specie) => {
        var speciesId = specie.id
        var speciesName = specie.name;
        var speciesPoints = specie.points;
        var scoreType = specie.scoreType;
        var speciesCount = [];
        var speciesTimes = [];
        var speciesScores = 0;
         
        if (scoreType === 'QTY'){
          logs.forEach((log) => {
           
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesTimes.push(log.catchDate);
            }
          }); 
            
          var count = speciesCount.length;
          var points = parseFloat(count * speciesPoints);
          var totalPoints = (points + speciesScores)
          boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
						teamName: boatLog.teamName,
            boatThm: boatLog.boatThm,
            boatClass: boatLog.boatClass,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints: totalPoints,
            speciesTimes: speciesTimes
          });
          boatPoints.push(totalPoints);
        }
        if (scoreType === 'LBS'){
          logs.forEach((log) => {
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesPoints = speciesPoints * log.lbs;
            }
          });
          if(speciesCount.length > 0) {
            boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
						teamName: boatLog.teamName,
            boatThm: boatLog.boatThm,
            boatClass: boatLog.boatClass,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints,
          });
          }
          boatLbsPoints.push(totalPoints);
        }
      });
      boatTotal = boatPoints.reduce(function(sum, value) {
        return sum + value;
      }, 0);
      boatTotals.push({
        id: boatLog.boatId,
        boatName: boatLog.boatName,
				teamName: boatLog.teamName,
        boatClass: boatLog.boatClass,
        boatThm: boatLog.boatThm,
        speciesCounts: boatCounts,
        total: boatTotal,
        lastFishTime: this.formatDate(boatLog.lastFishTime)
      })
    })
    return boatTotals
  }

  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    
    boatScores.sortOn("total", "lastFishTime");
    boatScores.reverse();
    
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })
    return bScores;  
  }

  formatDate(date) {
    var options = {
      month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Costa_Rica',
    };
    var newDate = new Date(date);
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);
    return formattedDate;
  }

  catchDate(date) {
    var catchDate = new Date(date)
    var hour = catchDate.getHours();
    var secs = catchDate.getSeconds();
    var ampm = hour >= 12 ? 'PM' : 'AM';
    var minutes = catchDate.getMinutes();
    hour = hour % 12;
    hour = hour ? hour : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var dateString = hour + ':' + minutes + ':' + secs + '' + ampm;
    
    return dateString
  }

  nextVideo(currentVideo) {
    const videos = this.state.vidList;
    var i = videos.length - 1;
    var index = videos.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videos[next]
    })
  }

  buffering(currentVid) {
      console.log('BUFFERING')
      setInterval(this.nextVideo(currentVid), 10000)
  }

  handleButtonPress (event) {
      var day = event.target.id;
      if(day === "All"){
          var currentLogs = this.state.fishLogs;
          var currentBoatScores = this.state.boatScores;
      } else if (day === "Day1") {
          var currentLogs = this.state.fishLogsOne;
          var currentBoatScores = this.state.boatScoresOne;
      } else if (day === "Day2") {
          var currentLogs = this.state.fishLogsTwo;
          var currentBoatScores = this.state.boatScoresTwo;
      }
    this.setState({
        currentLogs,
        currentBoatScores
    })
    event.preventDefault();
  }

  handleButtonRelease (event) {
    var day = event.target.id;
      if(day === "All"){
          var currentLogs = this.state.logs;
          var currentBoatScores = this.state.boatScores;
      } else if (day === "Day1") {
          var currentLogs = this.state.fishLogsOne;
          var currentBoatScores = this.state.boatScoresOne;
      } else if (day === "Day2") {
          var currentLogs = this.state.fishLogsTwo;
          var currentBoatScores = this.state.boatScoresTwo;
      }
    this.setState({
        currentLogs,
        currentBoatScores,
		currentDayState: day
    })
    event.preventDefault();
  }
  render () {
    const h = this.state.time.getHours()
		const m = this.state.time.getMinutes()
		const s = this.state.time.getSeconds()
    return (
      <div className="main-container">
          <TelevisionBreakpoint>
            <div style={{width: '100%'}}>
              <div style={{fontSize: '100px', justifyContent: 'flex-end', width: '100%'}}><center>{h}:{(m < 10 ? '0' + m : m)}:{(s < 10 ? '0' + s : s)} {h < 12 ? 'am' : 'pm'}</center></div>
              <div style={{zIndex: -1, display: this.state.loadingVis, display: 'flex', justifyContent: 'space-evenly'}}>
                <div style={{width: '50%'}}> <Logs logs={this.state.fishLogs}/></div>
                <div style={{width: '50%', marginLeft:'20px'}}><Scroller boatScores={this.state.boatScores} boatClass={'General'}/></div>
              </div>
            </div>
          </TelevisionBreakpoint>
          <DesktopBreakpoint>
            <div>
              <div style={{fontSize: '20px'}}>{h+ ':' + m + ':' + s}</div>
              <div style={{zIndex: -1, display: this.state.loadingVis, padding: '5%', display: 'flex', justifyContent: 'space-evenly'}}>
                <div style={{width: '50%'}}> <Logs logs={this.state.fishLogs}/></div>
                <div style={{width: '50%'}}><Scroller boatScores={this.state.boatScores} boatClass={'General'}/></div>
              </div>
            </div>
          </DesktopBreakpoint>
          <TabletBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis, padding: '5%'}}>
                <Logs logs={this.state.fishLogs}/>
            </div>
        </TabletBreakpoint>
        <PhoneBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis, padding: '5%'}}>
                <Logs logs={this.state.fishLogs}/>
            </div>
        </PhoneBreakpoint>
      </div> 
    );
  }
}

export default PescadoraLogs;


// WEBPACK FOOTER //
// ./src/pages/tournaments/pescadora/PescadoraLogs.js